<template>
    <div>
        <page-title heading="Tambah Stok BHP" :breadcrumb="[
          {
            label: 'Manajamen Stok',
            link: '/stok',
          },
          {
            label: 'Tambah Stok Obat & BHP',
            active: true,
          },
        ]" class="layout gantung ninja-shadow" />

        <div id="add-stok-bhp" class="container-fluid">
            <div class="card card-box mb-3 ninja-shadow __zoom_display">
                <div class="card-body">
                    <div v-for="(bhp, index) in obatList" :key="index" class="card card-box mb-3">
                        <div class="card-body">
                            <b-row>
                                <b-col md="11">
                                    <b-row>
                                        <b-col md="6">
                                            <b-row class="align-items-center">
                                                <b-col md="3">
                                                    <label class="required mb-md-0">Nama BHP</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <vue-select-clearable id="medicineOpt" style="font-size: 13px"
                                                        :options="medicineOpt" v-model="bhp.layanan_id"
                                                        :class="{'is-invalid' : obatList[index].errorLayananId}"
                                                        @input="changeMedicine($event, index)" placeholder="Pilih BHP">

                                                    </vue-select-clearable>
                                                    <div class="mt-3" :class="{'d-none' : obatList[index].errorLayananId}"></div>
                                                    <div class="text-danger"
                                                        :class="{'d-none' : !obatList[index].errorLayananId}">
                                                        {{obatList[index].errorLayananIdMsg}}
                                                    </div>
                                                </b-col>
                                            </b-row>

                                            <b-row class="align-items-center">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Stok Saat Ini</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input v-model="bhp.stok" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>

                                            <b-row class="align-items-center mt-3">
                                                <b-col md="3">
                                                    <label class="required mb-md-0">Stok Masuk</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'number'" min="0" v-model="bhp.stok_in"
                                                        :ref="'stok_in_' + index"
                                                        :class="{'is-invalid' : obatList[index].errorStokIn}"
                                                        v-on:keydown.188.capture.prevent.stop
                                                        v-on:keydown.190.capture.prevent.stop
                                                        @keyup="checkStockValue($event.target.value, index)"
                                                        @click="checkStockValue($event.target.value, index)"></b-input>
                                                    <div class="text-danger"
                                                        :class="{'d-none' : !obatList[index].errorStokIn}">
                                                        {{obatList[index].errorStokInMsg}}
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row class="align-items-center mt-3" v-if="bhp.layanan_id">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Total Stok</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'text'" v-model="bhp.total_stok" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>
                                            <b-row class="align-items-center mt-3" v-if="bhp.layanan_id">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Satuan</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'text'" :value="bhp.satuan_name || (bhp.layanan_id && bhp.layanan_id.satuan_name)" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        
                                        <b-col md="6">
                                            <b-row class="align-items-center" v-if="!bhp.layanan_id">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Total Stok</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'text'" v-model="bhp.total_stok" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>
                                            <!-- Additional fields that show before catatan -->
                                            <b-row class="align-items-center" v-if="bhp.layanan_id && bhp.layanan_id.kfa">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Manufactur</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'text'" v-model="bhp.manufactur" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>
                                            <b-row class="align-items-center mt-3" v-if="bhp.layanan_id && bhp.layanan_id.kfa">
                                                <b-col md="3">
                                                    <label class="mb-md-0">HET</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'text'" :value="format_money(bhp.het)" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>
                                            <b-row class="align-items-center" :class="bhp.layanan_id && bhp.layanan_id.kfa ? 'mt-3': ''" v-if="bhp.layanan_id">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Harga Beli</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'text'" :value="format_money(bhp.harga_beli)" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>
                                            <b-row class="align-items-center mt-3" v-if="bhp.layanan_id">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Margin</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'text'" :value="format_money(bhp.margin)" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>
                                            <b-row class="align-items-center mt-3" v-if="bhp.layanan_id">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Harga Jual</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-input :type="'text'" :value="format_money(bhp.tarif)" :readonly="true">
                                                    </b-input>
                                                </b-col>
                                            </b-row>
                                            <b-row class="align-items-center mt-3">
                                                <b-col md="3">
                                                    <label class="mb-md-0">Catatan</label>
                                                </b-col>
                                                <b-col md="9">
                                                    <b-form-textarea id="textarea" v-model="bhp.note"
                                                        placeholder="input catatan pendukung. Contoh: Masa berlaku BHP 20 September 2025, pembelian batch 1." rows="3" max-rows="6">
                                                    </b-form-textarea>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="1" class="my-auto">
                                    <b-button variant="danger" style="
                                        padding: 0.5rem 0.8rem;
                                        border-radius: 100%;
                                        margin-right: 15px;
                                        " v-if="obatList.length > 1" @click="removeMedicine(index)">
                                        <font-awesome-icon icon="minus" />
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <b-row class="text-center">
                        <b-col md="12">
                            <b-button variant="primary" style="
                                        padding: 0.5rem 0.8rem;
                                        border-radius: 100%;
                                        " @click="addMedicine()">
                                <font-awesome-icon icon="plus" />
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-row>
                <b-col md="12" class="text-right">
                    <b-button variant="danger" class="mr-3" @click="cancelMedicine()">
                        Batal
                    </b-button>
                    <b-button variant="primary" :disabled="errorValidation" @click="saveMedicine()">
                        Simpan
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faPlus,
    faMinus,
    faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { lastIndexOf } from "core-js/internals/enum-bug-keys";
library.add(faPlus, faMinus, faInfoCircle);

export default {
    components: {
        // "font-awesome-icon": FontAwesomeIcon,
        "vue-select-clearable": () => import("@/components/VueSelectClearable.vue")
    },
    data() {
        return {
            selectedId: JSON.parse(this.$route.query.selectedId),
            satuanOpt: [],
            medicineOpt: [],
            obatList: [
                this.getInitialStok()
            ],
            mapAttr: {
                'layanan_id': {
                    'error': 'errorLayananId',
                    'label': 'Obat'
                },
                'stok_in': {
                    'error': 'errorStokIn',
                    'label': 'Obat masuk'
                },
            },
            errorValidation: true,
        }
    },
    computed: {
        ...mapGetters(["getKlinikId", "getRolesName"])
    },
    created() {
        this.getMedicineOption();
    },
    methods: {
        async getSatuanOpt() {
            let path = `klinik/satuan/list`;
            let response = await this.$axios.get(path);

            this.satuanOpt = response.data.data;
        },
        async getMedicineOption() {
            let path = `klinik/obat/list?klinik_id=${this.getKlinikId}&type=bhp`;
            let response = await this.$axios.get(path);
            this.medicineOpt = response.data.data;
            // get status
            await this.getSatuanOpt();

            let setObatList = [];
        
            if (this.selectedId.length > 0) {
                for (let obatId of this.selectedId) {
                    let dt = this.medicineOpt.find(item => item.value == obatId)
                    let st = this.satuanOpt.find(item => item.value == dt.satuan_id)

                    setObatList.push({
                        layanan_id: dt,
                        satuan_id: st,
                        stok: dt.stock,
                        total_stok: dt.stock,
                        stok_in: 0,
                        note: "",
                        errorLayananId: false,
                        errorLayananIdMsg: "",
                        errorStokIn: false,
                        errorStokInMsg: "",
                        errorSatuanId: false,
                        errorSatuanIdMsg: "",
                        errorRow: false,
                        // Additional fields from the selected BHP
                        manufactur: dt.kfa ? dt.kfa.manufacturer : dt.manufactur,
                        het: dt.kfa ? dt.kfa.het_price : dt.het,
                        harga_beli: dt.harga_beli,
                        margin: dt.margin,
                        tarif: dt.tarif,
                        satuan_name: dt.satuan_name
                    });
                }
            } else {
                setObatList.push(this.getInitialStok());
            }

            this.obatList = setObatList;
        },
        getInitialStok() {
            return {
                layanan_id: null,
                satuan_id: null,
                stok: 0,
                total_stok: 0,
                stok_in: 0,
                note: "",
                errorLayananId: false,
                errorLayananIdMsg: "",
                errorStokIn: false,
                errorStokInMsg: "",
                errorRow: false,
                // Additional fields to show when nama bhp is selected
                manufactur: null,
                het: null,
                harga_beli: 0,
                margin: 0,
                tarif: 0,
                satuan_name: null
            }
        },
        checkStockValue(value, index) {
            let val = /[-.,]/.test(value) || isNaN(value) || value == "" ? 0 : parseInt(value);
            this.isEmpty(val, 'stok_in', index)
            this.obatList[index].stok_in = val;
            // Only calculate total_stok based on stok_in if no nama bhp is selected
            // Otherwise, it should include the existing stock from the selected bhp
            if (this.obatList[index].layanan_id) {
                this.obatList[index].total_stok = val + parseInt(this.obatList[index].stok || 0);
            } else {
                this.obatList[index].total_stok = val;
            }
            this.checkInputRow(this.obatList);
        },
        isEmpty(e, field, index) {
            let msg = `${this.mapAttr[field].label} harus diisi`;

            if (!e && (e != '0') || e == 0) {
                this.setErrorValidation(true, index, this.mapAttr[field].error, msg);
                return true;
            } else {
                this.setErrorValidation(false, index, this.mapAttr[field].error, '');
                return false;
            }
        },
        isDuplicateMedicine(e, index) {
            let duplicate = false;

            // reset error message
            for (let [i, obat] of this.obatList.entries()) {
                this.obatList[i].errorLayananId = false;
                this.obatList[i].errorLayananIdMsg = '';
            }

            if (!e) {
                this.setErrorValidation(true, index, 'errorLayananId', 'Obat harus diisi');
                duplicate = false;
                return;
            }

            for (let [i, obat] of this.obatList.entries()) {
                if (i == index) continue;
                if (e.value == obat.layanan_id.value) {
                    this.setErrorValidation(true, i, 'errorLayananId', 'Duplikat data obat');
                    duplicate = true;
                }
            }

            return duplicate;
        },
        setErrorValidation(status, index, attr, msg) {
            this.obatList[index][attr] = status;
            this.obatList[index].errorRow = status;
            this.obatList[index][`${attr}Msg`] = status ? msg : '';
        },
        changeMedicine(e, index) {
            let stok = e && e.stock ? parseFloat(e.stock) : 0;
            let stokIn = this.obatList[index].stok_in ? parseFloat(this.obatList[index].stok_in) : 0;
            
            // clear data first
            this.obatList[index].stok = 0;
            this.obatList[index].total_stok = this.obatList[index].stok_in;
            this.obatList[index].satuan_id = null;
            this.obatList[index].manufactur = null;
            this.obatList[index].het = null;
            this.obatList[index].harga_beli = null;
            this.obatList[index].margin = null;
            this.obatList[index].tarif = null;
            this.obatList[index].satuan_name = null;

            if (e)  { 
                this.obatList[index].stok = stok;
                this.obatList[index].total_stok = stok + stokIn;
                this.obatList[index].satuan_id = e.satuan_id;
                
                // Set additional fields from the selected BHP
                if (e.kfa) {
                    this.obatList[index].manufactur = e.kfa.manufacturer;
                    this.obatList[index].het = e.kfa.het_price;
                }

                // Also store harga_beli, margin, and tarif if available
                this.obatList[index].harga_beli = e.harga_beli;
                this.obatList[index].margin = e.margin;
                this.obatList[index].tarif = e.tarif;
                this.obatList[index].satuan_name = e.satuan_name;
            }

            this.setErrorValidation(false, index, 'errorLayananId', '')
            if (this.isDuplicateMedicine(e, index)) {
                this.setErrorValidation(true, index, 'errorLayananId', 'Duplikat data obat');
            }
            this.checkInputRow(this.obatList);
        },
        checkInputRow(data) {
            for (let [i, obat] of data.entries()) {
                if (!obat['layanan_id'] || !obat['stok_in'] || obat.errorRow) {
                    this.errorValidation = true;
                    return true;
                } else
                    this.errorValidation = false;
            }

            return this.errorValidation;
        },
        checkAddRow(data, index) {
            let attr = ['layanan_id', 'stok_in'];

            let isValid = true;

            for (let i of attr) {
                if (this.isEmpty(data[i], i, index)) isValid = false;
            }

            return isValid;
        },
        addMedicine() {
            let lastIndex = this.obatList.length - 1;
            let data = this.obatList[lastIndex];

            if (!this.checkAddRow(data, lastIndex)) return;

            this.obatList.push(this.getInitialStok());
            this.errorValidation = true;
        },
        removeMedicine(index) {
            this.obatList.splice(index, 1);
            this.checkInputRow(this.obatList);
        },
        cancelMedicine() {
            this.$swal({
                title: 'Batal',
                html: `Apakah Anda yakin untuk membatalkan pengisian data stok ? <br/> Data yang telah ditulis tidak akan tersimpan.`,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: "Tidak",
                confirmButtonText: "Ya",
                width: "650px"
            }).then(async (res) => {
                if (res.value) {
                    this.$router.push({ name: 'klinik-stok-bhp' })
                }
            });
        },
        saveMedicine() {
            let path = `klinik/stock`;
            let data = [...this.obatList].map(item => ({
                layanan_id: item.layanan_id.value,
                // Use the satuan_id value from the original selected item
                satuan_id: item.layanan_id ? item.layanan_id.satuan_id : 0,
                stock: item.stok_in,
                note: item.note
            }))

            this.$axios.post(path, data)
                .then((response) => {
                    this.$swal({
                        // title: 'Berhasil',
                        html: 'Data stok berhasil ditambahkan',
                        type: 'success'
                    })

                    this.$router.push({ name: 'klinik-stok-bhp' })
                })
                .catch(error => {
                    this.$swal({
                        title: 'Gagal',
                        html: 'Stok gagal ditambahkan',
                        type: 'error'
                    })
                })
        },
        format_money(value) {
            if (!value) return "Rp 0";
            const formatter = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });

            return formatter.format(value);
        }
    }
}

</script>

<style lang="scss">
.layout-gantung {
    border-radius: 0px 0px 10px 10px;
    max-height: 250px;
}

.ninja-shadow {
    box-shadow: 0px 8px 15px 0px lightgrey;
}

.required:after {
    content: " *";
    color: red;
    padding-left: 5px;
}

.is-invalid {
    border: 1px solid red;
    border-radius: 0.29rem;
}

#add-stok-bhp {
    .__zoom_display {
        zoom: 80%;
    }

    .vs__dropdown-option {
        white-space: wrap;
    }

    .vs--single .vs__selected {
        width: 95%;
    }
}
</style>